import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Workspace Logo", -1)
const _hoisted_3 = { class: "card col-md-6" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_12 = { class: "card-footer" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.loading ? "Loading" : "Workspace company logo"), 1),
          _hoisted_7,
          _createElementVNode("input", {
            type: "file",
            id: "logo",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileUpload($event, 'logo')))
          }, null, 32),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.org.config.images.logo,
                  width: "150"
                }, null, 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Uploading"))
            : _createCommentVNode("", true),
          (_ctx.errorMsg)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.errorMsg), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ms-2 float-end",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: _ctx.submitted
        }, _toDisplayString(_ctx.submitted ? "Storing" : "Update"), 9, _hoisted_13),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearStyles && _ctx.clearStyles(...args))),
          class: "cursor-pointer btn btn-dark"
        }, " Reset Styles ")
      ])
    ])
  ]))
}